// 示例
// const promises = [2, 3, 5, 7, 11, 13, 15].map(id => () => fetch(`https://www.baidu.com/s?wd=${id}`));

// batchToRun(promises, 2).then(v => {
//     console.log('result', v);
// });

/**
 * 传递一个 promise 二维数组，依赖 promise.then 方法顺序执行每一个函数（包含异步）
 * @param {*} chunks 接收一个 promise 函数的二维数组
 * @return {Promise} 返回一个 promise
 */
const runChunks = function (chunks) {
    const result = [];
    return new Promise((resolve, reject) => {
        let current = -1;
        const len = chunks.length;
        const next = function (i) {
            if (i <= current) return reject(new TypeError('重复调用'));
            if (i >= len) return resolve(result);
            current = i;

            const chunk = chunks[current];
            Promise.all(chunk.map(c => c()))
                .then(values => {
                    result.push(...values);
                    next(i + 1);
                })
                .catch(e => reject(e));
        };
        next(0);
    });
};

/**
 * 分批运行一组 promise
 * @param {*} fns 接收一个 primose 的函数数组
 * @param {*} n 每组执行几个 promise 函数
 * @return {Array} 返回一个结果的数组
 */
const batchToRun = function (fns, n = 0) {
    if (!Array.isArray(fns)) {
        throw new Error('fns 必须为函数数组');
    }

    if (n === 0) {
        return Promise.all(fns);
    }

    const chunks = [];
    for (let i = 0, len = fns.length; i < len; i += n) {
        chunks.push(fns.slice(i, i + n));
    }

    return runChunks(chunks);
};

export {
    batchToRun as default,
    runChunks
};
